"use client";

import { useEffect, useState } from "react";
import axios from "axios";

interface Announcement {
  id: number;
  text: string;
  is_active: boolean;
  sort_order: number;
}

export function AnnouncementMarquee() {
  const [items, setItems] = useState<Announcement[]>([]);

  useEffect(() => {
    axios
      .get<Announcement[]>("/api/announcements")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  // 각 공지 사이 구분자 + 매끄러운 무한 스크롤 위해 두 번 반복
  const text = items.map((a) => a.text).join("  ●  ");

  return (
    <div className="border-b border-primary/40 bg-primary text-bg overflow-hidden">
      <div className="relative h-9 flex items-center">
        <span className="absolute left-3 z-10 text-sm">📢</span>
        <div className="absolute left-10 right-0 overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap">
            <span className="text-xs font-bold text-bg px-4">{text}</span>
            <span className="text-xs font-bold text-bg px-4" aria-hidden>{text}</span>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes marquee {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee ${Math.max(20, text.length * 0.18)}s linear infinite;
        }
      `}</style>
    </div>
  );
}
